var React = require('react');

function Tasks (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 8.25c-.55 0-1-.45-1-1v-2.5c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1H13zm0 10c-.55 0-1-.45-1-1v-2.5c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1H13zm0 10c-.55 0-1-.45-1-1v-2.5c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1H13zM4 23a3.001 3.001 0 0 1 0 6C2.344 29 .963 27.656.963 26S2.344 23 4 23zM9.781 4.313 4.294 9.801a.796.796 0 0 1-1.1 0L.219 6.839a.75.75 0 0 1 0-1.063l.981-.981a.75.75 0 0 1 1.062 0l1.419 1.381L7.662 2.22a.75.75 0 0 1 1.062 0l1.063 1.031a.756.756 0 0 1-.006 1.063zm0 9.974-5.494 5.494a.796.796 0 0 1-1.1 0L.218 16.812a.75.75 0 0 1 0-1.063l.981-.981a.75.75 0 0 1 1.062 0l1.419 1.381 3.981-3.981a.75.75 0 0 1 1.062 0l1.063 1.063a.748.748 0 0 1-.006 1.056z"}));
}

Tasks.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Tasks;

Tasks.default = Tasks;
